import { render, staticRenderFns } from "./ChildList.vue?vue&type=template&id=060b1e4d&scoped=true&"
import script from "./ChildList.vue?vue&type=script&lang=js&"
export * from "./ChildList.vue?vue&type=script&lang=js&"
import style0 from "./ChildList.vue?vue&type=style&index=0&id=060b1e4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b1e4d",
  null
  
)

export default component.exports